import type { SxProps, Theme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";

export const stack: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2.5),
});

export const planCard: SxProps<Theme> = (theme) => ({
  border: 1.5,
  borderColor: "primary.main",
  bgcolor: alpha(theme.palette.primary.main, 0.06),
  borderRadius: 2.25,
  p: { xs: 2, md: 2.75 },
  display: "flex",
  flexDirection: "column",
  gap: 1.5,
});

export const planHeader: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

export const planTitle: SxProps<Theme> = {
  fontSize: { xs: "0.875rem", md: "1rem" },
  fontWeight: 800,
};

export const planPrice: SxProps<Theme> = {
  fontSize: { xs: "0.84375rem", md: "0.9375rem" },
  fontWeight: 700,
  color: "primary.main",
};

export const planNote: SxProps<Theme> = {
  fontSize: { xs: "0.71875rem", md: "0.78125rem" },
  color: "text.secondary",
};
